import React, { SyntheticEvent } from 'react';
import cx from 'classnames';

import { getTailwindColor, scaleImage } from '@trqk/utils';

const iconId = 'gap-analysis';

const originalDimensions = {
    width: 24,
    height: 24,
};

// A custom gap analysis icon based on the Stockholm icon style
export const IconGapAnalysis = (props: IconProps): JSX.Element => {
    const fillColor = props?.fillColor ?? 'black';
    const fill = getTailwindColor(fillColor);
    const { height, width } = scaleImage(originalDimensions, props);
    const { addClasses, handleClick } = props;
    const classNames = cx(addClasses, 'inline', {
        'cursor-pointer': handleClick,
    });

    return (
        <svg
            aria-labelledby={iconId}
            className={classNames}
            height={height}
            onClick={(e: SyntheticEvent): void => {
                if (handleClick) {
                    handleClick(e);
                }
            }}
            viewBox={`0 0 ${originalDimensions.width} ${originalDimensions.height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <title id={iconId}>Chat Icon</title>
            <g
                style={{ display: 'inline' }}
                transform="rotate(90 15.87 16.388) scale(.96098)"
                fillRule="evenodd"
                fill="none"
            >
                <path d="M0 0h24v24H0z" />
                <rect
                    style={{
                        display: 'inline',
                        opacity: 1,
                        strokeWidth: 0.810203,
                    }}
                    rx="1.5"
                    height="10.503"
                    width="3"
                    y="9.497"
                    x="13"
                    opacity=".3"
                    fill={fill}
                />
                <rect
                    style={{
                        display: 'inline',
                        strokeWidth: 0.86289,
                    }}
                    rx="1.5"
                    height="8.19"
                    width="3"
                    y="11.81"
                    x="8"
                    fill={fill}
                />
                <rect
                    style={{
                        display: 'inline',
                        strokeWidth: 0.921787,
                    }}
                    rx="1.5"
                    height="7.647"
                    width="3"
                    y="12.353"
                    x="18"
                    fill={fill}
                />
                <rect
                    style={{
                        display: 'inline',
                    }}
                    rx="1.5"
                    height="7"
                    width="3"
                    y="13"
                    x="3"
                    fill={fill}
                />
            </g>
            <g
                fill="none"
                fillRule="evenodd"
                transform="rotate(-90 5.698 13.078) scale(.96098)"
            >
                <path
                    style={{
                        display: 'inline',
                    }}
                    d="M0 0h24v24H0z"
                />
                <rect
                    style={{
                        display: 'inline',
                        fill,
                        fillOpacity: 1,
                        strokeWidth: 0.554512,
                    }}
                    fill={fill}
                    opacity=".3"
                    x="13"
                    y="15.08"
                    width="3"
                    height="4.92"
                    rx="1.5"
                />
                <rect
                    style={{
                        display: 'inline',
                        opacity: 0.3,
                    }}
                    fill={fill}
                    x="8"
                    y="9"
                    width="3"
                    height="11"
                    rx="1.5"
                />
                <rect
                    style={{
                        display: 'inline',
                        opacity: 0.3,
                        strokeWidth: 0.73315,
                    }}
                    fill={fill}
                    x="-1.977"
                    y="15.22"
                    width="3"
                    height="4.838"
                    rx="1.5"
                />
                <rect
                    style={{
                        display: 'inline',
                        opacity: 0.3,
                        strokeWidth: 1.11925,
                    }}
                    fill={fill}
                    x="3"
                    y="11.231"
                    width="3"
                    height="8.769"
                    rx="1.5"
                />
            </g>
        </svg>
    );
};
